import React, { useState } from "react";
import TemplateArticleHelp from "../TemplateArticleHelp/TemplateArticleHelp";
import styles from "./Transactions.module.css";
import { ReactComponent as ArrowDownBold } from "../../../assets/arrowDownBold.svg";
import { ReactComponent as ConectionsGrayIcon } from "../../../assets/ConectionsGrayIcon.svg";
import { ReactComponent as PenIconOutline } from "../../../assets/PenIconOutlineGray.svg";
import { ReactComponent as TransactionsGreenIcon } from "../../../assets/TransactionsGreenIcon.svg";
import { useTranslation } from "react-i18next";

const Transactions = ({setSelectedCategory}) => {
  const { t } = useTranslation("helpPage");

  const [activeArticles, setActiveArticles] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  });

  const handleClick = (index) => {
    setActiveArticles((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };

  return (
    <div>
      <TemplateArticleHelp
        title={t('transactions')}
        description={t('transactionsDesc')}
        Icon={TransactionsGreenIcon}
        setSelectedCategory={setSelectedCategory}
      >
        <div className={styles.articlesContent}>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(1)} 
            >
              {t('invoiceManagement')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[1] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
       {t('createATransaction')}
          <div style={{ margin: "20px auto", width: "fit-content" }}>
                <PenIconOutline />
              </div>
            </div>
            {t('configureinvoiceLocation')}
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(2)} 
            >
              {t('queriesTransaction')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[2] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
             {t('analyzeTransactions')}
             
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('documentApproval')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
                {t('documentAprovalDesc')}
                <ul>
                    <li>{t('documentAprovalList1')}</li>
                    <li>{t('documentAprovalList2')}</li>
                    <li>{t('documentAprovalList3')}</li>
                </ul>

            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('transactionStatuses')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
        {t('documentsImpacts')}
             <ul>
                <li>{t("documentsImpactsList1")}</li>
                <li>{t("documentsImpactsList2")}</li>
                <li>{t("documentsImpactsList3")}</li>
                <li>{t("documentsImpactsList4")}</li>
                <li>{t("documentsImpactsList5")}</li>
                <li>{t("documentsImpactsList6")}</li>
             </ul>
            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(4)} 
            >
              {t('paymentAutomation')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[4] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
                {t('paymentAutomationDesc')}
              <ol>
                <li>{t('paymentAutomationDescList1')}</li>
                <div style={{ margin: "20px auto", width: "fit-content" }}>
                <ConectionsGrayIcon />
              </div>
                <li>{t('paymentAutomationDescList2')}</li>
                <li>{t('paymentAutomationDescList3')}
                    <ul>
                        <li>{t('paymentAutomationDescList4')}</li>
                        <li>{t('paymentAutomationDescList5')}</li>
                    </ul>
                </li>
                <li>{t('paymentAutomationDescList6')}</li>
                <li>{t('paymentAutomationDescList7')}</li>
              </ol>
              <br />
              <br />
              {t('paymentAutomationDescList8')}
             
            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(4)} 
            >
              {t('stripeRefunds')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[4] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
             {t('facturagptWillAllowAutomatedInvoice')}
            </div>
          </div>
        </div>
      </TemplateArticleHelp>
    </div>
  );
};

export default Transactions;
